import {BaseModel} from './baseModel';

export class ControlAction extends BaseModel {

  number: number;
  address: string; // parametro per Android
  serial: number;
  name: string;
  icon: number;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);
    return this;
  }

  getDarkGrayImage() {
    return "assets/img/action/icon_" + (this.number+1) + "_darkgray.png";
  }

  getGrayImage() {
    return "assets/img/action/icon_" + (this.number+1) + "_gray.png";
  }

  getGrayMarkImage() {
    return "assets/img/action/icon_" + (this.number+1) + "_gray_mark.png";
  }

  getImage(shared: boolean) {
    if(shared) {
      return this.getGrayMarkImage();
    }
    return this.getGrayImage();
  }

}
